module.exports = __webpack_public_path__ + "media/images/svg/pull-quote-d01b51256e4cb312a10a14998e4c813b.svg";